'use client'

import { useEffect, useState } from 'react'
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }
    // Initial check
    checkMobile()
    // Add event listener
    window.addEventListener('resize', checkMobile)
    // Cleanup
    return () => window.removeEventListener('resize', checkMobile)
  }, [])
  return isMobile
} 
